import { render, staticRenderFns } from "./ServiceDashboardSectionEmptyState.vue?vue&type=template&id=80319b38&scoped=true&"
import script from "./ServiceDashboardSectionEmptyState.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboardSectionEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDashboardSectionEmptyState.vue?vue&type=style&index=0&id=80319b38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80319b38",
  null
  
)

export default component.exports